/**
 * Formats a Date as a YYYY-MM-DD string using local date components.
 * This preserves the face-value date the user picked in the calendar,
 * avoiding UTC conversion that shifts the day by the timezone offset.
 */
export function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * @deprecated Use formatLocalDate instead for date-only fields.
 * Kept for backward compatibility with query param callers that need a Date object.
 */
export default function adjustForTimezone(date: Date): Date {
  const adjustedDate = new Date(date);
  let timezoneOffset: number = date.getTimezoneOffset();
  if (timezoneOffset < 0) {
    adjustedDate.setMinutes(date.getMinutes() - timezoneOffset);
    return adjustedDate;
  }
  adjustedDate.setMinutes(date.getMinutes() + timezoneOffset);
  return adjustedDate;
}
